import { assignInlineVars } from '@vanilla-extract/dynamic';
import { forwardRef, ReactNode } from 'react';
import { theme } from '../../theme.css';
import * as css from './Row.css';

export interface RowProps extends React.AllHTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  gap?: string;
  grow?: boolean;
  justifyContent?:
    | 'start'
    | 'end'
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'stretch'
    | 'left'
    | 'right'
    | 'space-evenly'
    | 'space-around'
    | 'space-between';
  alignItems?:
    | 'start'
    | 'end'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'stretch';
}

export const Row = forwardRef<HTMLDivElement, RowProps>(
  ({ gap, grow, alignItems, justifyContent, ...props }, ref) => {
    return (
      <div
        ref={ref}
        {...props}
        className={`${css.row} ${props.className ?? ''}`}
        style={{
          ...assignInlineVars({
            [css.gap]: gap ?? theme.space.none,
            [css.grow]: grow ? '0 1 auto' : 'unset',
            [css.width]: grow ? '100%' : 'auto',
            [css.alignItems]: alignItems ?? 'start',
            [css.justifyContent]: justifyContent ?? 'start',
          }),
          ...props.style,
        }}
      >
        {props.children}
      </div>
    );
  }
);

Row.displayName = 'Row';
